import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { Checkbox, FormControlLabel } from "@mui/material";

function FileDataAuditRelevantCheckbox({ control }) {
  return (
    <Controller
      name="auditRelevant"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={<Checkbox {...field} checked={field.value} />}
          label="Audit-Relevant"
        />
      )}
    />
  );
}

FileDataAuditRelevantCheckbox.propTypes = {
  control: PropTypes.object,
};

export default FileDataAuditRelevantCheckbox;
